/*
    应用根组件
*/
import React,{Component} from 'react'
import {BrowserRouter,Router,Switch,Route} from 'react-router-dom'
import Main from './pages/main/main'
import DeliveryQuery from './pages/delivery/delivery-query'
import TrackQuery from './pages/delivery/track-query'
import Login from './pages/login/login'
import MobileUpload from './pages/order-info/mobile-upload'
import Subscribe from './pages/mobile/subscribe'
import SubscribeList from './pages/mobile/subscribe-list'
import './assets/css/main.less'
import authorizeRoute from "./components/authorize/authorizeRoute";
import CompanyBindOpt from './pages/mobile/company-bind-opt'
import history from './utills/history';
import SubscribeBoxList from "./pages/mobile/subscribe-box-list";
import SubscribeBoxSearch from "./pages/mobile/subscribe-box-search";
import SubscribeBoxSearchList from "./pages/mobile/subscribe-box-search-list";

const RouteHoc = authorizeRoute(Route)


class App extends Component {
    render () {
        return (
            <Router history={history}>
                <Switch>
                    <RouteHoc path='/mobileup/:orderId' component={MobileUpload}/>
                    <Route path='/sub/box/search/:boxNo' component={SubscribeBoxSearchList}/>
                    <Route path='/sub/box/search' component={SubscribeBoxSearch}/>
                    <Route path='/sub/box' component={SubscribeBoxList}/>
                    <Route path='/sub' component={SubscribeList}/>
                    <Route path='/companyBindOpt' component={CompanyBindOpt}/>
                    <Route path='/login' component={Login}/>
                    <Route path='/delivery' component={DeliveryQuery}/>
                    <Route path='/trackQuery/:orderNo/:gpsNo' component={TrackQuery}/>
                    <Route path='/trackQuery/:orderNo' component={TrackQuery}/>
                    <RouteHoc path='/' component={Main}/>
                </Switch>
            </Router>
        )
    }
}
export default App